import { SERVICE_NAME } from "@/config/serviceNames";
import { EntityType, Module } from "@/constants";
import { requests } from ".";

const WhatsAppService = {
  disableWhatsappForLocation: (locationId: string) =>
    requests(SERVICE_NAME.LC_PHONE_API).delete(
      `whatsapp/location/${locationId}/cancelSubscription/`
    ),

  disconnectWhatsappIntegrationForLocation: (locationId: string) =>
    requests(SERVICE_NAME.LC_PHONE_API)
      .log({
        module: Module.WHATSAPP,
        entityType: EntityType.LOCATION,
        entityId: locationId,
      })
      .delete(
      `whatsapp/support/location/${locationId}/disconnect/`
    ),

  resetTemplateSyncStatus: (locationId: string) =>
    requests(SERVICE_NAME.LC_PHONE_API)
      .log({
        module: Module.WHATSAPP,
        entityType: EntityType.LOCATION,
        entityId: locationId,
      })
      .put(
        `whatsapp/support/location/${locationId}/reset-template-sync-status`,
        undefined,
      ),
};

export default WhatsAppService;
